const OpenDay = () => {
    const openday = document.querySelector('.single-openday');
    
    if (!openday) return;

    // Variabile per infoWindow
    let infoWindow = null;

    // Inizializzazione della mappa
    const initOpenDayMap = () => {
        const mapContainer = document.querySelector('.single-openday__map');
        const strutture = document.querySelectorAll('.single-openday__struttura');
        const closeButtons = document.querySelectorAll('.single-openday__map-layers-close');
        const markers = document.querySelectorAll('.marker');
        
        if (!mapContainer || markers.length === 0) return;

        // Configurazione della mappa
        let mapArgs = {
            zoom: parseInt(mapContainer.dataset.zoom) || 7,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false
        };

        // Creazione mappa
        const map = new google.maps.Map(mapContainer, mapArgs);
        map.markers = [];

        // Salva l'istanza della mappa globalmente
        window.openDayMapInstance = map;

        // Aggiunta markers
        markers.forEach((marker) => {
            initMarker(marker, map, strutture);
        });

        // Centraggio mappa sui markers
        centerMap(map);

        // Salva la posizione iniziale dopo che la mappa ha finito di centrarsi
        google.maps.event.addListenerOnce(map, 'idle', function() {
            map.initialCenter = map.getCenter();
            map.initialZoom = map.getZoom();
        });

        // Chiudi infowindow quando si clicca sulla mappa
        google.maps.event.addListener(map, "click", function(event) {
            if (infoWindow) infoWindow.close();
        });

        // Gestione filtro regione - inizializza tutti i select2
        const regioneSelects = document.querySelectorAll('.map_regione');
        regioneSelects.forEach((select, index) => {
            // Assegna un ID univoco se non ce l'ha
            if (!select.id) {
                select.id = `map_regione_${index}`;
            }
            
            jQuery(`#${select.id}`).select2({
                theme: "bootstrap-5",
                dropdownParent: jQuery(`#${select.id}`).parent(),
                placeholder: 'Filtra per regione',
                allowClear: true,
            }).on('change select2:clear', (e) => {
                const regione = e.target.value || '';
                filterMarkersByRegion(map, regione);
            });
        });

        // Gestione chiusura strutture
        closeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const struttura = this.closest('.single-openday__struttura');
                if (struttura) {
                    struttura.classList.remove('active');
                    
                    // Mostra di nuovo il layer dei filtri quando si chiude la struttura
                    const filtersLayer = document.querySelector('.single-openday__filters.--map');
                    if (filtersLayer) {
                        filtersLayer.style.display = 'block';
                    }
                    
                    // Solo su desktop: ripristina la posizione precedente della mappa
                    if (window.innerWidth >= 992 && map) {
                        restorePreviousMapPosition(map);
                    }
                }
            });
        });

        // Gestione click sulle strutture nei filtri
        initFilterStruttureClick(strutture);

        // Gestione view toggle mobile
        initViewToggle();

        // Gestione pulsante "Mostra di più"
        initLoadMoreButton();

        // Gestione form prenotazione
        initFormPrenotazione();
    };

    // Inizializzazione marker
    const initMarker = ($marker, map, strutture) => {
        // Get position from marker.
        let lat = $marker.dataset.lat;
        let lng = $marker.dataset.lng;
        let id = $marker.dataset.id;
        let regione = $marker.dataset.regione;

        let latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };

        // Create marker instance.
        let marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: {
                url: '/wp-content/themes/korian-master-theme/images/map-pin-openday.svg',
                size: new google.maps.Size(37, 53),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(18, 53)
            },
        });

        // Aggiungiamo proprietà al marker
        if (regione) marker.regione = regione;
        if (id) marker.id = id;

        // Evento click sul marker
        google.maps.event.addListener(marker, 'click', function() {
            // Solo su desktop: salva posizione corrente prima di aprire la struttura
            if (window.innerWidth >= 992) {
                saveCurrentMapPosition(map);
            }
            
            // Nascondi il layer dei filtri quando si apre una struttura
            const filtersLayer = document.querySelector('.single-openday__filters.--map');
            if (filtersLayer) {
                filtersLayer.style.display = 'none';
            }
            
            // Disattiva tutte le strutture
            strutture.forEach(s => s.classList.remove('active'));
            
            // Trova la struttura corrispondente
            const strutturaCorrispondente = Array.from(strutture).find(s => s.dataset.id === id);
            if (strutturaCorrispondente) {
                strutturaCorrispondente.classList.add('active');
            }
        });

        // Aggiunta del marker alla mappa
        map.markers.push(marker);
    };

    // Funzione per centrare la mappa sui markers
    const centerMap = (map) => {
        if (!map.markers.length) return;
        
        const bounds = new google.maps.LatLngBounds();
        
        map.markers.forEach(function(marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    };

    // Funzione per filtrare i markers per regione
    const filterMarkersByRegion = (map, regione) => {
        // Filtra i markers sulla mappa
        map.markers.forEach(marker => {
            if (!regione || marker.regione === regione) {
                marker.setVisible(true);
            } else {
                marker.setVisible(false);
            }
        });

        // Filtra anche le strutture nei filtri
        const filterStrutture = document.querySelectorAll('.single-openday__filter-struttura');
        filterStrutture.forEach(struttura => {
            const strutturaRegione = struttura.dataset.regione;
            if (!regione || strutturaRegione === regione) {
                struttura.style.display = 'block';
            } else {
                struttura.style.display = 'none';
            }
        });

        if (!regione) {
            // Ripristina la posizione iniziale
            if (map.initialCenter && map.initialZoom) {
                map.setCenter(map.initialCenter);
                map.setZoom(map.initialZoom);
            }
        } else {
            // Trova i marker visibili e centra la mappa su di essi
            const visibleMarkers = map.markers.filter(m => m.getVisible());
            if (visibleMarkers.length) {
                const bounds = new google.maps.LatLngBounds();
                visibleMarkers.forEach(marker => {
                    bounds.extend({
                        lat: marker.position.lat(),
                        lng: marker.position.lng()
                    });
                });
                map.fitBounds(bounds);
            }
        }
    };

    // Gestione click sulle strutture nei filtri
    const initFilterStruttureClick = (strutture) => {
        const filterStrutture = document.querySelectorAll('.single-openday__filter-struttura');
        const map = window.openDayMapInstance;
        
        filterStrutture.forEach(filterStruttura => {
            filterStruttura.addEventListener('click', function() {
                const strutturaId = this.dataset.strutturaId;
                
                if (strutturaId) {
                    // Solo su desktop: salva posizione corrente e zoom sulla struttura
                    if (window.innerWidth >= 992 && map) {
                        saveCurrentMapPosition(map);
                        zoomToStruttura(map, strutturaId);
                    }
                    
                    // Nascondi il layer dei filtri quando si apre una struttura
                    const filtersLayer = document.querySelector('.single-openday__filters.--map');
                    if (filtersLayer) {
                        filtersLayer.style.display = 'none';
                    }
                    
                    // Disattiva tutte le strutture
                    strutture.forEach(s => s.classList.remove('active'));
                    
                    // Trova la struttura corrispondente nella sezione principale
                    const strutturaCorrispondente = Array.from(strutture).find(s => s.dataset.id === strutturaId);
                    if (strutturaCorrispondente) {
                        strutturaCorrispondente.classList.add('active');
                    }
                }
            });
        });
    };

    // Salva la posizione corrente della mappa prima di zoomare su una struttura
    const saveCurrentMapPosition = (map) => {
        map.previousCenter = map.getCenter();
        map.previousZoom = map.getZoom();
    };

    // Zoom sulla struttura specifica
    const zoomToStruttura = (map, strutturaId) => {
        const marker = map.markers.find(m => m.id === strutturaId);
        if (marker) {
            map.setCenter(marker.getPosition());
            map.setZoom(15);
        }
    };

    // Ripristina la posizione precedente della mappa
    const restorePreviousMapPosition = (map) => {
        if (map.previousCenter && map.previousZoom) {
            map.setCenter(map.previousCenter);
            map.setZoom(map.previousZoom);
        }
    };

    // Gestione view toggle mobile
    const initViewToggle = () => {
        const viewToggleItems = document.querySelectorAll('.view-toggle__item');
        const mapContainer = document.querySelector('.single-openday__map');
        const filtersContainer = document.querySelector('.single-openday__filters.--map');
        
        if (!viewToggleItems.length || !mapContainer || !filtersContainer) return;

        // Verifica se siamo su mobile (Bootstrap breakpoint lg = 992px)
        const isMobile = () => window.innerWidth < 992;

        viewToggleItems.forEach(item => {
            item.addEventListener('click', function() {
                // Funziona solo su mobile
                if (!isMobile()) return;
                
                const target = this.dataset.target;
                
                // SIMULA SEMPRE UN "INDIETRO": Chiudi tutto quello che è aperto
                
                // 1. Chiudi tutte le strutture attive
                const activeStrutture = document.querySelectorAll('.single-openday__struttura.active');
                activeStrutture.forEach(struttura => {
                    struttura.classList.remove('active');
                });
                
                // 2. Chiudi il form di prenotazione se aperto
                const formLayer = document.querySelector('.single-openday__form-layer');
                if (formLayer && formLayer.style.display === 'block') {
                    formLayer.style.display = 'none';
                    
                    // Ripristina l'header del form per future aperture
                    const formHeader = formLayer.querySelector('.single-openday__form-header');
                    if (formHeader) {
                        formHeader.style.display = 'block';
                    }
                }
                
                // 3. Procedi con il toggle normale
                
                // Rimuovi classe active da tutti gli item
                viewToggleItems.forEach(i => i.classList.remove('active'));
                
                // Aggiungi classe active all'item cliccato
                this.classList.add('active');
                
                // Gestisci la visualizzazione
                if (target === '#viewMap') {
                    // Mostra mappa, nascondi elenco strutture
                    mapContainer.style.display = 'block';
                    filtersContainer.style.display = 'none';
                    
                    // SEMPLICE: sempre ripristina posizione iniziale quando si passa alla mappa senza filtro
                    const mapInstance = window.openDayMapInstance;
                    const regioneSelect = document.querySelector('.map_regione');
                    
                    if (mapInstance && (!regioneSelect || !regioneSelect.value)) {
                        mapInstance.setCenter(mapInstance.initialCenter);
                        mapInstance.setZoom(mapInstance.initialZoom);
                    }
                } else if (target === '#viewPhoto') {
                    // Mostra elenco strutture, nascondi mappa
                    mapContainer.style.display = 'none';
                    filtersContainer.style.display = 'block';
                }
            });
        });

        // Imposta lo stato iniziale (solo su mobile)
        const setInitialState = () => {
            if (!isMobile()) {
                // Su desktop, ripristina la visualizzazione standard
                mapContainer.style.display = '';
                filtersContainer.style.display = '';
                return;
            }

            // Su mobile, imposta lo stato iniziale
            const defaultActive = document.querySelector('.view-toggle__item.active');
            if (defaultActive) {
                const defaultTarget = defaultActive.dataset.target;
                if (defaultTarget === '#viewPhoto') {
                    mapContainer.style.display = 'none';
                    filtersContainer.style.display = 'block';
                } else {
                    mapContainer.style.display = 'block';
                    filtersContainer.style.display = 'none';
                }
            }
        };

        // Imposta stato iniziale
        setInitialState();

        // Gestisci resize della finestra
        window.addEventListener('resize', setInitialState);
    };

    // Gestione pulsante "Mostra di più"
    const initLoadMoreButton = () => {
        const loadMoreButton = document.querySelector('.single-openday__filters-strutture__loadmore-button');
        const filtersContainer = document.querySelector('.single-openday__filters.--map');
        const loadMoreContainer = document.querySelector('.single-openday__filters-strutture__loadmore');
        
        if (!loadMoreButton || !filtersContainer) return;

        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Cambia l'altezza del container da vh ad auto per mostrare tutte le strutture
            filtersContainer.style.height = 'auto';
            filtersContainer.style.maxHeight = 'none';
            
            // Nascondi il pulsante "Mostra di più" dopo il click
            if (loadMoreContainer) {
                loadMoreContainer.style.display = 'none';
            }
            
            // Aggiungi una classe per eventuali stili aggiuntivi
            filtersContainer.classList.add('expanded');
        });
    };

    // Gestione form di prenotazione
    const initFormPrenotazione = () => {
        const formLayer = document.querySelector('.single-openday__form-layer');
        const formCloseBtn = document.querySelector('.single-openday__form-close');
        const prenotazioneTriggers = document.querySelectorAll('.single-openday__struttura-prenotazione-trigger');
        
        if (!formLayer) return;

        let currentStrutturaId = null;

        // Gestione click sui trigger di prenotazione
        prenotazioneTriggers.forEach(trigger => {
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                
                const strutturaId = this.dataset.strutturaId;
                const strutturaNome = this.dataset.strutturaNome;
                const pacchettoNome = this.dataset.pacchettoNome;
                
                // Salva l'ID della struttura corrente
                currentStrutturaId = strutturaId;
                
                // Nascondi la struttura corrente quando si apre il form
                const strutturaCorrente = document.querySelector(`.single-openday__struttura[data-id="${strutturaId}"]`);
                if (strutturaCorrente) {
                    strutturaCorrente.classList.remove('active');
                }
                
                // Aggiorna le informazioni nel layer
                const strutturaNameSpan = formLayer.querySelector('.struttura-name');
                
                if (strutturaNameSpan) strutturaNameSpan.textContent = strutturaNome;
                
                // Popola i campi hidden della form (se esistono)
                populateHiddenFields(strutturaNome, pacchettoNome);
                
                // Mostra il layer della form
                formLayer.style.display = 'block';
            });
        });

        // Gestione chiusura form e ritorno alla struttura
        if (formCloseBtn) {
            formCloseBtn.addEventListener('click', function() {
                // Nascondi il layer della form
                formLayer.style.display = 'none';
                
                // Riattiva la struttura di origine se esiste
                if (currentStrutturaId) {
                    const strutturaOriginale = document.querySelector(`.single-openday__struttura[data-id="${currentStrutturaId}"]`);
                    if (strutturaOriginale) {
                        strutturaOriginale.classList.add('active');
                    }
                }
                
                // Ripristina la visibilità dell'header per future aperture
                const formHeader = formLayer.querySelector('.single-openday__form-header');
                if (formHeader) {
                    formHeader.style.display = 'block';
                }
            });
        }

        // Gestione invio form - nasconde header quando form viene inviata
        initFormSubmissionHandler(formLayer);
    };

    // Funzione per popolare i campi della form Gravity Forms
    const populateHiddenFields = (strutturaNome, pacchettoNome) => {
        // Aspetta un po' per assicurarsi che la form sia renderizzata
        setTimeout(() => {
            // Cerca il container del campo struttura e il suo input
            const strutturaContainer = document.querySelector('.input-struttura');
            if (strutturaContainer) {
                const strutturaField = strutturaContainer.querySelector('input[type="text"]');
                if (strutturaField) {
                    strutturaField.value = strutturaNome;
                    strutturaField.readOnly = true;
                    // Aggiungi classe per styling se necessario
                    strutturaField.classList.add('readonly-field');
                    // Trigger change event per Gravity Forms
                    strutturaField.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
            
            // Cerca il container del campo checkup e il suo input
            const pacchettoContainer = document.querySelector('.input-checkup');
            if (pacchettoContainer) {
                const pacchettoField = pacchettoContainer.querySelector('input[type="text"]');
                if (pacchettoField) {
                    pacchettoField.value = pacchettoNome;
                    pacchettoField.readOnly = true;
                    // Aggiungi classe per styling se necessario
                    pacchettoField.classList.add('readonly-field');
                    // Trigger change event per Gravity Forms
                    pacchettoField.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

        }, 100);
    };

    // Gestione invio form Gravity Forms
    const initFormSubmissionHandler = (formLayer) => {
        // Observer per intercettare quando viene mostrata la conferma
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        // Controlla se è stata aggiunta una conferma di Gravity Forms
                        if (node.classList && (
                            node.classList.contains('gform_confirmation_wrapper') ||
                            node.classList.contains('gform_confirmation_message') ||
                            node.querySelector('.gform_confirmation_wrapper') ||
                            node.querySelector('.gform_confirmation_message')
                        )) {
                            // Nasconde l'header quando la form è stata inviata
                            const formHeader = formLayer.querySelector('.single-openday__form-header');
                            if (formHeader) {
                                formHeader.style.display = 'none';
                            }
                        }
                    }
                });
            });
        });

        // Osserva i cambiamenti nel container della form
        const formContainer = formLayer.querySelector('.single-openday__form-container');
        if (formContainer) {
            observer.observe(formContainer, {
                childList: true,
                subtree: true
            });
        }

        // Alternativa: intercetta anche l'evento di submit del form
        const formElement = formLayer.querySelector('form');
        if (formElement) {
            formElement.addEventListener('submit', function() {
                // Piccolo delay per permettere a Gravity Forms di processare
                setTimeout(() => {
                    const confirmationWrapper = formLayer.querySelector('.gform_confirmation_wrapper, .gform_confirmation_message');
                    if (confirmationWrapper) {
                        const formHeader = formLayer.querySelector('.single-openday__form-header');
                        if (formHeader) {
                            formHeader.style.display = 'none';
                        }
                    }
                }, 500);
            });
        }
    };

    // Inizializza la mappa quando Google Maps è caricato
    if (window.google && window.google.maps) {
        initOpenDayMap();
    } else {
        // Se Google Maps non è ancora caricato, attendi l'evento
        window.addEventListener('load', function() {
            if (window.google && window.google.maps) {
                initOpenDayMap();
            }
        });
    }
};

export default OpenDay;

